export const getCsvFromObjectArray = (array: any, excludedFields = []) => {
  const csv = Object.keys(array[0]).filter(([key]: any) => !excludedFields.includes(key)).map((key) => key).join(',') + '\n'
  const rows = array.map(order => Object.entries(order).filter(([key]) => !excludedFields.includes(key))
    .map(([, value]) => value).join(',')).join('\n')
  return csv + rows
}
export const downloadCsv = (csv: any, name: any) => {
  const link = document.createElement('a')
  link.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv))
  link.setAttribute('download', name + '.csv')
  link.click()
}
